"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeSelector = exports.brands = void 0;
var react_1 = __importDefault(require("react"));
var brands_1 = __importDefault(require("./brands"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
exports.brands = Object.keys(brands_1.default);
exports.ThemeSelector = function (_a) {
    var onChange = _a.onChange, value = _a.value, className = _a.className;
    var options = exports.brands.map(function (label, value) { return ({
        value: value.toString(),
        label: label
    }); });
    var classes = classnames_1.default('theme-selector', className);
    return (react_1.default.createElement("div", { className: classes },
        react_1.default.createElement(__1.SzSelect, { placeholder: "Changer de th\u00E8me", options: options, value: value, onChange: onChange, isSearchable: true, name: "theme-selector" })));
};
